import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChooseAddressesModalComponent } from './choose-addresses-modal.component';

@NgModule({
  declarations: [ChooseAddressesModalComponent],
  imports: [CommonModule],
  exports: [ChooseAddressesModalComponent],
})
export class ChooseAddressesModalModule {}
